import {PK} from "@/class/data-type";
import store from "@/store/store";
import axios from "@/axios";
import events from "@/events/events";
import {link} from "@/class/link";

export class baseModel{
    
    objectType = "";
    parentObjectType = "";
    
    data = [];
    
    _pk = new PK("pk");
    _story = new PK("story");
    _data = {};
    _globaInfo = {};
    
    _isList = false;
    
    init(){
        // initialise default value
        this.data.forEach((d) => {
            this[d.name] = d.default;
        })
        this.setGlobalInfo();
    }
    
    setId(pk){
        this._pk.set(pk)
        return this;
    }
    setStoryId(pk){
        this._story.set(pk)
        return this;
    }
    setGlobalInfo(){
        this._globaInfo = store.getters.type(this.getObjectType())
    }
    
    setDataReq(data, preview = false){
        
        if(data[this._pk.name]){
            this.setId(data[this._pk.name])
        }
        if(data[this._story.name]){
            this.setStoryId(data[this._story.name])
        }
        
        this.data.forEach((d) => {
            let name = d.export || d.name
            
            if(typeof data[name] === "undefined") return;
            this._data[d.name] = new d.type(data[name]);
            
            this[d.name] = this._data[d.name].valueOf();
            
            if(Array.isArray(this[d.name])){
                this[d.name] = this[d.name][0]
            }
            
        })
    
        return this;
    }
    getId(){
        return this._pk.get();
    }
    getStoryId() {
        return this._story.get();
    }
    getObjectType(){
        return this.objectType;
    }
    getDataReq(){
        let data = {}
        this.data.forEach((d) => {
            
            if(d.readonly) return;
            
            let name = d.export || d.name;
            data[name] = this[d.name];
            
            // console.log(d.name, data[d.name])
            
            if(this[d.name].getReq) {
                data[name] = this[d.name].getReq();
                // console.log("EXISTE ",d.name, data[d.name])
                if(data[name] === "__delete__"){
                    delete data[name]
                }
            }
            
        })
        
        data[this._story.name] = this._story.get();
        
        return data;
    }
    getDeleteReq(){
        return {};
    }
    geGlobalInfoObject(){
        return this._globaInfo;
    }
    getLabelObject(){
        return this._globaInfo.label;
    }
    getIconObject(){
        return this._globaInfo.icon;
    }
    getRouteObject(){
        return this._globaInfo.route;
    }
    getObjectTypeParent(){
        if(this.parentObjectType !== "") return this.parentObjectType;
        return this.objectType;
    }
    getRoute(){
        return "/story/" + this.getStoryId() + "/"+this.getRouteObject()+"/" + this.getId()
    }
    toReq(){
        let data = {}
        
        data[this._pk.name] = this._pk.get();
        data[this._story.name] = this._story.get();
    
        this.data.forEach((d) => {
        
            let name = d.export || d.name;
            data[name] = this[d.name];
        
            if(this[d.name].toReq) {
                data[name] = this[d.name].toReq();
            }
        })
        
        return data;
    }
    
    isNew() {
        return this._pk.get() <= 0;
    }
    
    // FUNCTIONS
    async load(){
        
        if(this.isNew() && !this._isList){
            return true;
        }
        
        try {
            let url = !this._isList ? '/'+this.getRouteObject()+'/' + this.getId() + "/" : '/'+this.getRouteObject()+'/'
         
            let response = await axios.get(url);
            
            this.setDataReq(response.data)
            
            return true;
            
        } catch (e) {
            console.log(e)
            return false;
        }
    }
    
    async patch(champs){
        
        console.log("-------------- patch "+this.objectType+" | pk "+this.getId()+" | started --------------");
        
        let datas = {}
        let dataReq = this.getDataReq()
        
        if (!Array.isArray(champs)) {
            champs = [champs]
        }
        
        champs.forEach((key) => {
            datas[key] = dataReq[key];
        });
        
        events.$emit(this.getObjectTypeParent()+':save:start')
        
        try {
            let response = await axios.patch(this.getRouteObject()+"/" + this.getId() + "/", datas)
            
            this.setDataReq(response.data)
            
            events.$emit(this.getObjectTypeParent()+':save:end')
            
            console.log("-------------- patch "+this.objectType+" | pk "+this.getId()+" | success --------------");
            
            return true;
            
        }catch (e) {
            console.log("-------------- patch "+this.objectType+" | pk "+this.getId()+" | error --------------");
            events.$emit(this.getObjectTypeParent()+':save:error',"patch "+this.getObjectType()+" error")
    
            console.log(e)
            return false;
        }
        
    }
    
    async save(){
        
        console.log("-------------- save "+this.objectType+" | pk "+this.getId()+" | started --------------");
        
        let data = this.getDataReq();
        console.log(data)
        let fn = this.isNew() ? "post" : "patch";
        let url = this.getRouteObject();
        url += this.isNew() ? "/" : "/" + this.getId() + "/";
        
        events.$emit(this.getObjectTypeParent()+':save:start');
        
        try {
            let response = await axios[fn](url, data)
            
            this.setDataReq(response.data)
            
            events.$emit(this.getObjectTypeParent()+':save:end')
            console.log("-------------- save "+this.objectType+" | pk "+this.getId()+" | success --------------");
            return true;
            
        }catch (e) {
            events.$emit(this.getObjectTypeParent()+':save:error',"save "+this.getObjectType()+" error")
            console.log("-------------- save "+this.objectType+" | pk "+this.getId()+" | error --------------");
            console.log(e)
            return false;
        }
    }
    
    async delete(){
        
        if (this.isNew()){
    
            events.$emit(this.getObjectTypeParent()+':save:end')
            
            return true;
        }
        
        events.$emit(this.objectType+':save:start')
        
        console.log("-------------- delete "+this.objectType+" | pk "+this.getId()+" | started --------------");
        
        try {
            await axios.delete(this.getRouteObject() + "/" + this.getId() + "/", this.getDataReq(), this.getDeleteReq())
            
            console.log("-------------- delete "+this.objectType+" | pk "+this.getId()+" | success --------------");
            
            events.$emit(this.getObjectTypeParent()+':save:end')
            
            return true;
        }catch(e){
            
            events.$emit(this.getObjectTypeParent()+':save:error', "delete "+this.getObjectType()+" error")
            
            console.log("-------------- delete "+this.objectType+" | pk "+this.getId()+" | error --------------");
            console.log(e)
            return false;
        }
    }
    
}

export class baseModelLink extends baseModel{
    
    link = new link();
    
    getDataReq() {
        
        let data = super.getDataReq();
        
        return {...data, ...this.link.getDataReq()}
    }
    
    setDataReq(data, preview = false) {
        
        super.setDataReq(data, preview);
        
        this.link.load(data)
        
    }
    
    toReq(){
        let data = super.toReq()
        
        data = {...data, ...this.link.toReq()}
    
        return data;
    }
}